const initialState = {
  Success: false,
};

const SET_SUCCESS = "SET_SUCCESS";


export const setSuccess = (value) => ({
  type: SET_SUCCESS,
  payload: value,
});

const SidebarReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_SUCCESS:
      return { ...state, Success: action.payload };
    default:
      return state;
  }
};

export default SidebarReducer;
